export const FETCH_USER = "user/FETCH_USER";
export const FETCH_USER_SUCCESS = "user/FETCH_USER_SUCCESS";
export const FETCH_USER_FAILED = "user/FETCH_USER_FAILED";
export const CHANGE_PASSWORD = "user/CHANGE_PASSWORD";

export const ADD_USER_REQUEST = "user/ADD_USER_REQUEST";
export const ADD_USER_SUCCESS = "user/ADD_USER_SUCCESS";
export const ADD_USER_FAILURE = "user/ADD_USER_FAILURE";

export const REAUTHENTICATE_CHANGE_PASSWORD =
  "user/REAUTHENTICATE_CHANGE_PASSWORD";

export const FETCH_USERS_REQUEST = "user/FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "user/FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "user/FETCH_USERS_FAILURE";

export const FETCH_USER_BY_ID = "user/FETCH_USER_BY_ID";
export const FETCH_USER_BY_ID_SUCCESS = "user/FETCH_USER_BY_ID_SUCCESS";
export const CLEAR_USER_VALUES = "user/CLEAR_USER_VALUES";

export const UPDATE_CURRENT_USER_REQUEST = "user/UPDATE_CURRENT_USER_REQUEST";

export const UPDATE_USER_REQUEST = "user/UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "user/UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILED = "user/UPDATE_USER_FAILED";

export const SEARCH_USERS_REQUEST = "user/SEARCH_USERS_REQUEST";
export const SEARCH_USERS_SUCCESS = "user/SEARCH_USERS_SUCCESS";
export const SEARCH_USERS_FAILURE = "user/SEARCH_USERS_FAILURE";

export const FETCH_TOTAL_USERS_REQUEST = "user/FETCH_TOTAL_USERS_REQUEST";
export const FETCH_TOTAL_USERS_SUCCESS = "user/FETCH_TOTAL_USERS_SUCCESS";
export const FETCH_TOTAL_USERS_FAILURE = "user/FETCH_TOTAL_USERS_FAILURE";
export const CLEAR_TOTAL_USERS = "user/CLEAR_TOTAL_USERS";
